import { render, staticRenderFns } from "./FromStripe.vue?vue&type=template&id=513c4f20&scoped=true&"
import script from "./FromStripe.vue?vue&type=script&lang=js&"
export * from "./FromStripe.vue?vue&type=script&lang=js&"
import style0 from "./FromStripe.vue?vue&type=style&index=0&id=513c4f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c4f20",
  null
  
)

export default component.exports